import axios from "axios";

const API_URL = "/api/reviews";

export const getReviews = () => axios.get(API_URL);
export const getReview = (id) => axios.get(`${API_URL}/${id}`);
export const createReview = (data) => axios.post(API_URL, data);
export const updateReview = (id, data) => axios.put(`${API_URL}/${id}`, data);
export const deleteReview = (id) => axios.delete(`${API_URL}/${id}`);
